import React, { useState, useEffect } from "react";
import Login from "../Login";
import AuthService from "../../services/auth.service";
import { useNavigate } from 'react-router-dom';

 function Home() {
   let navigate = useNavigate();
   const [currentUser, setCurrentUser] = useState(undefined);
   useEffect(() => {
     const user = AuthService.getCurrentUser();
     if (user) {
       setCurrentUser(user);
     }
   }, []);
   AuthService.logout();
   if(currentUser)
   {
    navigate("/parkings");
      window.location.reload();
   }
   return (
     <div>
     {!currentUser && (<Login/>)}
    </div>
  );
 }
export default Home;
